import { createContext } from 'react'
import { AuthState } from '@/types/auth.type'

export interface AuthContextValue extends AuthState {
  signInWithAzureAD: () => Promise<void>
  signOutUser: () => Promise<void>
  refreshSession: () => Promise<void>
  getAccessToken: () => Promise<string | undefined>
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
